"use strict";import{IconCheckmark100 as e}from"../src/elements/IconCheckmark100.js";import{defineElement as c}from"@spectrum-web-components/base/src/define-element.js";c("sp-icon-checkmark100",e);
//# sourceMappingURL=sp-icon-checkmark100.js.map
